package one.healthium.insights.domain.models

sealed interface ActionModel {
    data class Video(
        val url: String,
    ) : ActionModel

    data class Insight(
        val id: String,
    ) : ActionModel

    data class Recipe(
        val id: String,
    ) : ActionModel

    data class Category(
        val id: String,
    ) : ActionModel

    data class Workout(
        val id: String,
    ) : ActionModel

    data class ShoppingList(
        val shoppingList: ShoppingListModel,
    ) : ActionModel

    data class MealPlan(
        val id: String,
    ) : ActionModel

    data class LogMeal(
        val nutrition: MealNutritionModel,
    ) : ActionModel

    data class Anchor(
        val id: String,
    ) : ActionModel

    data object UpdateFoodPreferences : ActionModel

    data class Favorite(
        val contentPreview: ContentPreviewModel,
    ) : ActionModel

    data object Share : ActionModel
}

fun ActionModel.testTag(prefix: String? = "") = when (this) {
    is ActionModel.Category -> "${prefix}_category"
    is ActionModel.Insight -> "${prefix}_insight"
    is ActionModel.MealPlan -> "${prefix}_meal_plan"
    is ActionModel.Recipe -> "${prefix}_recipe"
    is ActionModel.ShoppingList -> "${prefix}_shopping_list"
    is ActionModel.Video -> "${prefix}_video"
    is ActionModel.Workout -> "${prefix}_workout"
    is ActionModel.LogMeal -> "${prefix}_log_meal"
    is ActionModel.Anchor -> "${prefix}_anchor"
    is ActionModel.UpdateFoodPreferences -> "${prefix}_update_food_preferences"
    is ActionModel.Favorite -> "${prefix}_favorite"
    is ActionModel.Share -> "${prefix}_share"
}.trimStart('_')
